import React from "react";
import { Dialog } from '@mui/material';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import colors from "../../../../colors";
import { texts } from "../../../../general/texts";

const ThankYouDialog = ({ isDialogOpened, handleClose }) => {
    const isSmallScreen = useMediaQuery('(max-width:600px)');

    return (
        <Dialog
            open={isDialogOpened}
            onClose={handleClose}
            keepMounted
            fullWidth
            maxWidth="lg"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            PaperProps={{
                style: {
                    borderRadius: '20px',
                    width: '500px',
                    height: isSmallScreen ? '30vh' : '240px',
                    padding: isSmallScreen ? '15px' : '15px 35px',
                    zIndex: 888,
                    justifyContent: 'center',
                    background: colors.white
                },
            }}
        >
           <div>
            <p style={{textAlign: 'start', fontSize: '35px', fontFamily: 'GerberaBold', color: colors.orange, margin: '0 0 12px 0'}}>{texts['title-thanks']}</p>
            <p style={{textAlign: 'start', fontSize: '18px', fontFamily: 'GerberaMedium', color: colors.darkBlue, margin: '0px'}}>{texts['message-thanks-for-donation']}</p>
          </div>
        </Dialog>
    )
}
export default ThankYouDialog;